import type { FamilyMissionChallenge, RewardPolicy, RewardTransaction, RewardValueType, RewardWallet } from './models';

export function rewardTypeLabel(type: RewardValueType): string {
  return { allowance:'용돈', bonus:'보너스', 'saving-match':'저축 매칭', 'simulated-stock':'모의 주식 포인트' }[type];
}

export function validateFamilyMissionReward(amount: number, type: RewardValueType, policy: RewardPolicy): string | null {
  if (!Number.isFinite(amount) || amount < policy.minRewardAmount || amount > policy.maxRewardAmount) return `보상은 ${policy.minRewardAmount.toLocaleString('ko-KR')}원 이상 ${policy.maxRewardAmount.toLocaleString('ko-KR')}원 이하로 설정해 주세요.`;
  if (type === 'simulated-stock' && !policy.allowSimulatedStock) return '현재 운영 정책에서는 모의 주식 포인트를 사용할 수 없습니다.';
  return null;
}

export function submitFamilyMission(mission: FamilyMissionChallenge, note: string, now = new Date().toISOString()): FamilyMissionChallenge {
  if (!['active','held'].includes(mission.status)) return mission;
  return { ...mission, status:'submitted', submittedNote:note.trim(), submittedAt:now, updatedAt:now };
}

export function reviewFamilyMission(mission: FamilyMissionChallenge, decision: 'approved' | 'held', now = new Date().toISOString()): FamilyMissionChallenge {
  if (mission.status !== 'submitted') return mission;
  return { ...mission, status:decision, reviewedAt:now, updatedAt:now };
}

export function rewardTransactionForMission(mission: FamilyMissionChallenge, now = new Date().toISOString()): RewardTransaction {
  return {
    id:`reward_${mission.id}`, familyId:mission.familyId, childId:mission.childId, missionId:mission.id,
    type:mission.reward.type, amount:mission.reward.amount, status:'approved', memo:`${mission.title} 보상`, createdAt:now, approvedAt:now
  };
}

export function recordReward(wallet: RewardWallet, transaction: RewardTransaction, now = new Date().toISOString()): { wallet: RewardWallet; transaction: RewardTransaction } {
  if (transaction.status === 'recorded') return { wallet, transaction };
  const amount=Math.max(0,Number(transaction.amount||0));
  const next={...wallet,updatedAt:now};
  if(transaction.type==='saving-match') next.savingBalance+=amount;
  else if(transaction.type==='simulated-stock') next.simulatedInvestmentBalance+=amount;
  else next.allowanceBalance+=amount;
  return { wallet:next, transaction:{...transaction,status:'recorded',recordedAt:now} };
}

export function rewardWalletTotal(wallet: RewardWallet): number {
  return wallet.allowanceBalance + wallet.savingBalance + wallet.simulatedInvestmentBalance;
}

export function activeFamilyMissions(missions: FamilyMissionChallenge[], childId: string): FamilyMissionChallenge[] {
  return missions.filter((item)=>item.childId===childId&&!['completed','cancelled'].includes(item.status)).sort((a,b)=>String(a.dueAt).localeCompare(String(b.dueAt)));
}
